import type { MatterViewModel } from '~/modules/matters/matters.types';
import { UserRole, type User } from '~/shared/types/connect';

/**
 * Resolves experts from loaded matter rows (nested `matterExperts.expert` from GraphQL).
 * Use for list/detail UI instead of mock store experts.
 *
 * Optional `pickerExperts` fills ids missing from the matter graph (e.g. nested `expert`
 * not loaded on a row); matter-derived entries win when both exist.
 */
export function buildGetExpertByIdFromMatters(
  matters: MatterViewModel[],
  pickerExperts?: ReadonlyArray<{
    id: string;
    name: string;
    email: string;
    avatarUrl?: string | null;
  }>,
): (id: string) => User | undefined {
  const expertById = new Map<string, User>();
  for (const matter of matters) {
    for (const matterExpert of matter.matterExperts) {
      const nested = matterExpert.expert;
      if (!nested) {
        continue;
      }
      if (!expertById.has(nested.id)) {
        expertById.set(nested.id, {
          id: nested.id,
          name: nested.name,
          email: nested.email,
          role: UserRole.EXPERT,
          avatarUrl: nested.avatarUrl ?? undefined,
        });
      }
    }
  }
  if (pickerExperts) {
    for (const row of pickerExperts) {
      if (!expertById.has(row.id)) {
        expertById.set(row.id, {
          id: row.id,
          name: row.name,
          email: row.email,
          role: UserRole.EXPERT,
          avatarUrl: row.avatarUrl ?? undefined,
        });
      }
    }
  }
  return (id: string) => expertById.get(id);
}
